/**
 * Stock Chart Viewer - Dashboard Features
 * Handles Market Status and News Feed
 */

import { fetchCompanyNews } from '../api/finnhub.js';
import { elements } from '../ui/dom.js';

/**
 * Update Market Status Indicator (NYSE/NASDAQ)
 * Open: 9:30 AM - 4:00 PM ET (Mon-Fri)
 */
export function updateMarketStatus() {
    const now = new Date();

    // Convert to Eastern Time (ET)
    const etNow = new Date(now.toLocaleString('en-US', { timeZone: 'America/New_York' }));
    const day = etNow.getDay(); // 0=Sun, 6=Sat
    const hour = etNow.getHours();
    const minute = etNow.getMinutes();
    const timeVal = hour * 60 + minute;

    // Market Hours: 9:30 (570) - 16:00 (960)
    const MARKET_OPEN = 570;
    const MARKET_CLOSE = 960;

    let isOpen = false;
    let statusText = 'Closed';
    let statusClass = 'closed';

    if (day >= 1 && day <= 5) { // Mon-Fri
        if (timeVal >= MARKET_OPEN && timeVal < MARKET_CLOSE) {
            isOpen = true;
            statusText = 'Market Open';
            statusClass = 'open';
        } else if (timeVal < MARKET_OPEN) {
            statusText = 'Pre-Market';
            statusClass = 'pre-market';
        } else {
            statusText = 'After Hours';
            statusClass = 'after-hours';
        }
    } else {
        statusText = 'Weekend';
        statusClass = 'closed';
    }

    const statusEl = document.getElementById('market-status');
    if (statusEl) {
        statusEl.textContent = `● ${statusText} (ET ${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')})`;
        statusEl.className = `market-status ${statusClass}`;
    }
}

/**
 * Render News Feed for Symbol
 */
export async function renderNewsFeed(symbol) {
    const container = document.getElementById('news-feed-container');
    if (!container) return; // Feature might not be in DOM yet

    container.innerHTML = '<div class="loading-spinner"></div> Loading News...';

    try {
        const newsItems = await fetchCompanyNews(symbol);

        if (newsItems.length === 0) {
            container.innerHTML = '<p class="no-news">関連ニュースが見つかりませんでした。</p>';
            return;
        }

        const html = newsItems.map(item => `
            <div class="news-item">
                <a href="${item.url}" target="_blank" rel="noopener noreferrer">
                    <div class="news-content">
                        <div class="news-source">${item.source} • ${new Date(item.datetime * 1000).toLocaleDateString()}</div>
                        <h4 class="news-title">${item.headline}</h4>
                        <p class="news-summary">${item.summary ? item.summary.substring(0, 100) + '...' : ''}</p>
                    </div>
                    ${item.image ? `<div class="news-image"><img src="${item.image}" alt="News Image" onerror="this.style.display='none'"></div>` : ''}
                </a>
            </div>
        `).join('');

        container.innerHTML = html;

    } catch (error) {
        console.error('News render error:', error);
        container.innerHTML = '<p class="error">ニュースの取得に失敗しました。</p>';
    }
}

/**
 * Initialize Dashboard Features
 */
export function initDashboard() {
    updateMarketStatus();
    // Update status every minute
    setInterval(updateMarketStatus, 60000);
}
